import { useCallback, useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import 'react-toastify/dist/ReactToastify.css';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { currentDateAndTime, decodeData} from '../../Constants/constants';
import { IconButton, SubmitButton } from '../../Components/InputElements';
import { NoRecords } from '../../Components/Shimmer'; 
import MainPageLoader from '../../Components/MainPageLoader';
import BankCreate from './BankCreate';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const BankMaster = () => {
    const { apiURL, apiHeaderJSON,permissions } = useContext(ConfigContext);
    // getting permissions for access control
    const query = useQuery ();
    const encodedData = query.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const [rows, setRows] = useState([]);
    const [bankInfo, setBankInfo] = useState({});
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false);


const getList = useCallback(() => {
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetCompanyBanks`, { headers })
    .then((response) => {
        const { success,data } = response.data;
        if (success === true) {
            // console.log(data);
            setRows(data);
        }
        setLoading(false);
    })
    .catch((error)=>{
        setLoading(false);
        Swal.fire({
            title: '<strong>Error</strong>',
            html: error.message,
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
        });
    });
},[apiHeaderJSON,apiURL]);

useEffect(()=>{
    setLoading(true);
    getList();
},[getList])

const getInfo=(row)=>{
    setBankInfo(row);
    setModal(true);
}

const handleToggleSwitch = (company_bank_id, toggleButton) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    company_bank_id: company_bank_id,
                    activated: toggleButton ? "1" : "0",
                    date: currentDateAndTime(),
                }
                const headers = apiHeaderJSON;
                // console.log(data);
                axios
                    .post(`${apiURL}Masters/HandleCompanyBankStatus`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        // console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            getList(false);
                        }
                         Swal.fire({
                            title: `<strong>${response.data.success ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success ? 'success' : 'error',
                            showConfirmButton: true, 
                            allowOutsideClick: false,
                        });
                    })
                    .catch((error)=>{
                        Swal.fire({
                            title: '<strong>Error</strong>',
                            html: error.message,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }

    // const handleCompanyFilter = useCallback((selectedOption)=>{
    //     console.log("selectedOption",selectedOption);
    //     setIsChanged("1"); 
    //     setFilterData({ ...filterData, company_id: selectedOption?.value, location_id:"" }); 
    //     setRows([]); 
    // },[filterData]);
    // console.log("filterData?.company_id, filterData?.location_id",filterData?.company_id, filterData?.location_id);
    // const handleLocationFilter = useCallback((selectedOption)=>{
    //     setFilterData({ ...filterData, location_id: selectedOption?.value });
    // },[filterData]);

    
    const handleClose = useCallback(() => {
        setModal(!modal); 
        setBankInfo(false);
        getList(); 
    },[modal, getList]);
    const handleCloseModal = useCallback(() => {
        setModal(!modal);  
        setBankInfo(false);
    },[modal]);

    if (loading) return <MainPageLoader/>;

    return (
        <div class="main-content">
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Bank Master`} primary={`Home`} />
                    <div className="card">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">
                                {"Bank Master"}
                            </h4>
                            {/* 2 => Add */}
                            { decodedData?.includes(2) && ( 
                            <SubmitButton onClick={()=>{ setModal(!modal) }}
                            buttonName={"Create"}
                            type='primary' icon='ri-play-list-add-fill'/>
                            )}
                        </div>
                        <div className="card-body">
                            <div style={{ "minHeight":"40vh", "maxHeight": "65vh", "overflowY": "auto" }}>
                                <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                        <tr>
                                            <th width={"10%"} className=' text-center'>Sr.No.</th>
                                            <th>Bank Name</th>
                                            <th>Bank Account No.</th>
                                            <th>Bank IFSC Code</th>
                                            <th>Branch Name</th>
                                            <th width={"7%"} className=' text-center'>Status</th>
                                            {/* 3 => Edit */}
                                            { decodedData?.includes(3) && ( <th width={"10%"} className=' text-center'>Action</th> )}
                                        </tr>
                                    </thead>
                                    { rows?.length === 0 ?
                                        <tbody>
                                            <tr>
                                                <td colSpan={12}>
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        </tbody> :
                                        <tbody>
                                            {rows?.map((row, idx) => {
                                            return  <tr key={row?.company_bank_id}>
                                                        <td className=' text-center'>{idx + 1}</td>
                                                        <td>{row?.bank_name || "--"}</td>
                                                        <td>{row?.account_number || "--"}</td>
                                                        <td>{row?.ifsc_code || "--"}</td>
                                                        <td>{row?.branch_name || "--"}</td>
                                                        <td>
                                                            <div>
                                                                <ToggleSwitch isActive={row?.activated === "1" ? true : false} isExtFunc={true} onToggle={() => { handleToggleSwitch(row.company_bank_id, row?.activated === "1" ? false : true) }} />
                                                            </div>
                                                        </td>
                                                        {/* 3 => Edit */}
                                                        { decodedData?.includes(3) && (
                                                            <td>
                                                                <div className='d-flex justify-content-around gap-2'>
                                                                    <IconButton onClick={() => {getInfo(row)}} type='primary' icon='ri-edit-line' 
                                                                    tooltipName='Edit' tooltipPosition='bottom' />
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                            {modal && (<BankCreate onClick={handleCloseModal} handleClose={handleClose} data={bankInfo} />)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BankMaster;
